import { CommonService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const getManufacturesQueryKey = 'GetManufacturesForStockQueryKey';

const fetchManufactures = async () => {
  const data = await CommonService.getCommonGetManufactures();
  return data;
};

export const useGetManufacturesQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchManufactures>>,
      QueryError,
      Awaited<ReturnType<typeof fetchManufactures>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) => useQuery([getManufacturesQueryKey, ...(queryKey ?? [])], () => fetchManufactures(), options);
